module.exports = __webpack_public_path__ + "img/ELT.1d0ff9d9.svg";